<script setup>
import { useI18n } from 'vue-i18n';

import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  selectedCount: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['confirm', 'close']);

const { t } = useI18n();

const confirm = () => {
  emit('confirm');
};

const close = () => {
  emit('close');
};
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    @click="close"
  >
    <div
      class="bg-n-background rounded-lg shadow-lg p-6 max-w-md w-full mx-4"
      @click.stop
    >
      <div class="flex items-center gap-3 mb-4">
        <div
          class="flex-shrink-0 w-10 h-10 bg-n-red-3 rounded-full flex items-center justify-center"
        >
          <span class="i-lucide-alert-triangle text-n-red-11 text-lg" />
        </div>
        <div>
          <h3 class="text-lg font-medium text-n-slate-12">
            {{ t('BULK_ACTION.DELETE.CONFIRM_DELETE_TITLE') }}
          </h3>
          <p class="text-sm text-n-slate-11">
            {{
              t('BULK_ACTION.DELETE.CONFIRM_DELETE_MESSAGE', {
                count: selectedCount,
              })
            }}
          </p>
        </div>
      </div>
      <div class="flex gap-3 justify-end">
        <NextButton
          :label="t('BULK_ACTION.DELETE.CANCEL')"
          variant="ghost"
          @click="close"
        />
        <NextButton
          :label="t('BULK_ACTION.DELETE.CONFIRM')"
          variant="danger"
          @click="confirm"
        />
      </div>
    </div>
  </div>
  <template v-else />
</template>
